import { useState } from "react";
import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { CohostsObserver } from "@circle-react/components/LiveStreams/common/CohostsObserver";
import { usePunditUserContext } from "@circle-react/contexts";
import { INITIAL_HOST_NUMBER } from "@circle-react/helpers/liveStreamRoomHelpers";
import { CommunityMemberPicker } from "@circle-react-shared/CommunityMemberPicker";
import { FormItem } from "../../../Common/FormItem";
import { MembersPreview } from "../MembersPreview";

export const Cohosts = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const [isCohostLimitReached, setIsCohostLimitReached] = useState(false);
  const shouldDisableCommunityPickerSearch = isCohostLimitReached;
  const excludedMemberIds = currentCommunityMember
    ? [currentCommunityMember.id]
    : [];
  const cohostIds = useWatch<{ cohosts: number[] }>({ name: "cohosts" });

  return (
    <>
      <FormItem name="cohosts" className="z-20 mb-6" hideLabel>
        <CommunityMemberPicker
          name="cohosts"
          rules={{
            required: false,
          }}
          variant="modal"
          countLabel={t("live_streams.form.cohosts_added_label")}
          selectionLabel={t("live_streams.form.cohosts_selection_label")}
          searchPlaceholder={t("live_streams.form.cohosts_placeholder")}
          disableSearch={shouldDisableCommunityPickerSearch}
          excludedMemberIds={excludedMemberIds}
          renderAfterSelection={
            <CohostsObserver
              setIsLimitReached={setIsCohostLimitReached}
              initialCohostQuantity={INITIAL_HOST_NUMBER}
              shouldDisplayDisabledSearchMessage={
                shouldDisableCommunityPickerSearch
              }
            />
          }
        />
      </FormItem>
      <MembersPreview
        memberIds={Array.isArray(cohostIds) ? cohostIds : [cohostIds]}
        memberTagIds={[]}
        spaceGroupIds={[]}
        spaceIds={[]}
      />
    </>
  );
};
